import { render, staticRenderFns } from "./jobdetailsinfo.vue?vue&type=template&id=06555ba5"
import script from "./jobdetailsinfo.vue?vue&type=script&lang=js"
export * from "./jobdetailsinfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports